import { toast } from 'react-toastify';
import appApi from '../../../../../../api/app-api';
import globalSettingsStores from '../../../../../../stores/settings-stores';

export const saveNewExternalExamOperation = async (
  examName: string,
  symbol: string,
  majorSymbol: string,
  majorId: number,
  paymentServiceId: number | null,
  setLoading: (isLoading: boolean) => void,
  onHide: () => any,
) => {
  try {
    if (!examName || examName.length === 0) {
      toast.warn(`יש להזין את שם המקצוע`);
      console.warn(`External exam name must not be empty`);
      return;
    }
    if (examName.length < 1 || examName.length > 50) {
      toast.warn('על שם המקצוע להיות באורך של 1-50 תווים');
      return;
    }
    if (!symbol || symbol.length === 0) {
      toast.warn(`יש להזין את הסמל`);
      console.warn(`Symbol must not be empty`);
      return;
    }
    if (symbol.length < 1 || symbol.length > 50) {
      toast.warn('על הסמל להיות באורך של 1-50 תווים');
      return;
    }
    if (!majorSymbol || majorSymbol.length === 0) {
      toast.warn(`יש להזין את סמל המגמה`);
      console.warn(`Major symbol must not be empty`);
      return;
    }
    if (majorSymbol.length < 1 || majorSymbol.length > 50) {
      toast.warn('על סמל המגמה להיות באורך של 1-50 תווים');
      return;
    }
    if (!majorId || majorId <= 0) {
      toast.warn(`יש לבחור מגמה`);
      console.warn(`Major ID must be a positive integer`);
      return;
    }
    if (!paymentServiceId || paymentServiceId <= 0) {
      toast.warn(`יש לבחור שירות תשלום`);
      console.warn(`Payment service ID must be a positive integer`);
      return;
    }

    const existingExternalExam = globalSettingsStores.externalExams.find(
      (item) => item.examName === examName || item.symbol === symbol,
    );
    if (existingExternalExam) {
      toast.warn('שם מבחן חיצוני או סמל כבר קיימים במערכת');
      return;
    }

    setLoading(true);
    const res = await appApi.addExternalExam(
      examName,
      symbol,
      majorSymbol,
      majorId,
      paymentServiceId,
    );
    if (res.data.ok && res.data.body) {
      await globalSettingsStores.fetchSetting();
      toast.success(`הוספת ${examName} התבצעה בהצלחה`);
      onHide();
    } else {
      toast.error(
        `יצירת מבחן חיצוני ${examName} נכשלה, נסה שוב בעוד מספר רגעים...`,
      );
    }
    setLoading(false);

    return;
  } catch (e) {
    toast.error('הוספת מבחן חיצוני נכשלה, נסה שוב בעוד מספר רגעים...');
    console.error(
      `saveNewExternalExamOperation is failed with the exam name: ${examName}, symbol: ${symbol}, majorSymbol: ${majorSymbol}, majorId: ${majorId}, paymentServiceId: ${paymentServiceId} and the error: ${e}`,
    );
    setLoading(false);
  }
};
